



























































































































































































































































































































































































import Vue, { PropType } from 'vue';

import {
  Exhibition,
  exhibition as exhibitionM,
} from 'mostra';

import { v4 } from 'uuid';

export default Vue.extend({
  name: 'admin-admin-exhibition-modify',
  props: {
    exhibition: {
      type: Object as PropType<Exhibition>,
      required: true,
    },
    owner: {
      type: String as PropType<string>,
      required: true,
    },
  },
  methods: {
    addNewOffline(): void {
      const newOffline = exhibitionM.createNewOffline(v4());

      if (this.exhibition) {
        // this.offlines.push(newOffline);
        this.exhibition.data.offlines.push(newOffline);
      } else {
        throw new Error('exhibition is null');
      }
    },
    addNewMap(index: number): void {
      const newMap = exhibitionM.createNewOfflineMap();
      if (this.exhibition) {
        this.exhibition.data.offlines[index].maps.push(newMap);
      } else {
        throw new Error('exhibition is null');
      }
    },
    addNewCategory(index: number): void {
      const c = exhibitionM.createNewOfflineCategory();
      if (this.exhibition) {
        this.exhibition.data.offlines[index].categories.push(c);
      } else {
        throw new Error('exhibition is null');
      }
    },
    addNewDay(index: number): void {
      const c = exhibitionM.createNewOfflineDay(v4());
      if (this.exhibition) {
        this.exhibition.data.offlines[index].days.push(c);
      } else {
        throw new Error('exhibition is null');
      }
    },
  },
});
